export default[{
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_1.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_2.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_3.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_4.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_5.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_6.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_7.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_8.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_9.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_10.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_11.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_12.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_13.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_14.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_15.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_16.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_17.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_18.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_19.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_20.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_21.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_22.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_23.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_24.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_25.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_26.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_27.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_28.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_29.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_30.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_31.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_32.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_33.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_34.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_35.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_36.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_37.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_38.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_39.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_40.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_41.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_42.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_43.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_44.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_45.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_46.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_47.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_48.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_49.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_50.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_51.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_52.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_53.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_54.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_55.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_56.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_57.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_58.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_59.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_60.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_61.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_62.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_63.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_64.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_65.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_66.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_67.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_68.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_69.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_70.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_71.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_72.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_73.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_74.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_75.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_76.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_77.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_78.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_79.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_80.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_81.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_82.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_83.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_84.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_85.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_86.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_87.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_88.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/9jie/9jie_89.jpg"
}]


// WEBPACK FOOTER //
// ./src/pages/history/jie9.js